import { FC, useEffect, useState } from 'react';
import { TextInput } from '@common/components';
import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
  onSubmit: (e: string) => void;
  currStatement: string;
}

export const AccessibilityStatement: FC<Props> = ({ onSubmit, currStatement }) => {
  const [t] = useTranslation('widget');

  const [statement, setStatement] = useState('');

  useEffect(() => {
    setStatement(currStatement);
  }, [currStatement]);

  return (
    <Flex align="center" className={styles.inputUrl}>
      <TextInput
        label={`${t('accessibilityStatement')}`}
        placeholder={t('accessibilityStatementInputPlaceholder')}
        value={statement}
        onChange={(e) => {
          onSubmit(e.target.value);
          setStatement(e.target.value);
        }}
      />
    </Flex>
  );
};
